module.exports = __webpack_public_path__ + "img/UrduEx.7b0d7c00.svg";